export default function Reducer(state, action) {
  switch (action.type) {
    case 'GET_TOKEN':
      return {
        ...state,
        token: action.token,
      };
    case 'LOAD':
      return {
        ...state,
        chats: action.chats,
      };


    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
